export const getBannerList = `/postion/index/lists`;//获取banner
export const getNewsList = `/article/index/lists`;//获取新闻列表
export const getNewsDetail = `/article/index/show`;//获取新闻详情
export const getPageLinks = `/link/index/lists`;//页面链接 相关
export const getConfigObj = `/config/index/lists`;//配置项信息
export const userRegister = `/user/index/register`;//用户注册
export const userGetCheckCode = `/user/index/get_check_code`;//图形验证码
export const userFindPassword = `/user/index/find_password`;//找回密码
export const userGetCode = `/user/index/get_code`;//短信验证码
export const userLogin = `/user/index/login`;//用户注册
export const accountProfile = `/user/index/profile`;//用户注册
export const searchResults = `/search/index/lists`;//搜索
export const winWorks = `/works/award/lists`;//获奖作品
export const winWorksDetail = `/works/award/show`;//更新头像
export const getUserInfo = `/user/index/info`;//用户信息
export const getUserWorks = `/user/index/works`;//用户作品列表
export const delUserWorks = `/user/index/delete_works`;//删除用户作品
export const submitUserWorks = `/works/index/submit`;//提交用户作品
export const editUserWorks = `/user/works/edit`;//提交用户作品
export const updateAv = `/user/index/avatar`;//更新头像
export const getWorksDetail = `/works/index/show`;//更新头像
export const getRace = `/works/race`;//获取赛事赛道
export const getRaceInfo = `/works/race/info`;//获取赛事赛道
export const getRaceTopic = `/works/race/topic`;//获取赛事主题
export const getRaceTopicByGroup = `/works/race/topic/group`;
export const getRaceTopicInfo = `/works/race/topic/info`;
export const getDistrict = `/district/index/lists`//获取地址数据
export const getAwardList = `/works/award/lists`//获奖作品
export const getMyWorksShow = `/user/works/show`//获奖作品
export const getSearchSchoolFilter = `/school/search/filter`;
